import { render } from "./SetupAuthentication.vue?vue&type=template&id=03000202&scoped=true"
import script from "./SetupAuthentication.js?vue&type=script&lang=js&external"
export * from "./SetupAuthentication.js?vue&type=script&lang=js&external"

import "./SetupAuthentication.scss?vue&type=style&index=0&id=03000202&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03000202"]])

export default __exports__